export default {"src":"/_next/static/media/bookmark_filled.6e2a0720.svg","height":26,"width":22,"blurWidth":0,"blurHeight":0};